import React from 'react'
import { Link } from 'react-router-dom';
import errorImg from "@/assets/images/svg/404.svg";
import orexTradelogo from "@/assets/images/svg/orexlogo.svg";
import { publicRoutePaths } from '@/routes/public.routes.config';

const Index = () => {
    return (
        <div className='page-not-found-wrape'>
            <div>

                <div className='error404_logo'>

                    <div>
                        <Link to={"/"} className="brand" title='Home'>
                            <img src={orexTradelogo} alt="OrexTradeLogo" />
                        </Link>
                    </div>
                </div>


                <div className='error'>

                    <div className='error-img'>
                        <img src={errorImg} alt="Error" />
                    </div>

                    <div className='erro-text'>
                        <h1>Page Not Found </h1>
                        <p>Please try again later or feel free to contact us if the problem persists.</p>
                    </div>

                    <div className='error-reason'>

                        <h5>Possible Reasons</h5>
                        <p>The address may have been typed incorrectly.
                            It may be a broken or outdated link.</p>
                    </div>

                    <div>
                        <Link to={publicRoutePaths.HOME.path} title="Back to Home" className="btn group-btn">
                                Back to Home
                        </Link>
                    </div>

                </div>
            </div>
        </div>
    )

}

export default Index;